import React, {useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import { makeStyles } from "@material-ui/core/styles";

import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import FlightsStyles from "./styles/FlightStyles";
import FlightListExternalAccess from "./components/FlightListExternalAccess";
import { useCompaniesExternal } from "../../services/companies";
import {useQueryClient} from "react-query";
import FlightCapacityList from "./components/FlightCapcityList";


const AccessControl = require ("../../AccessControl");

const FlightCapacity = (props) => {
  const classes = makeStyles(FlightsStyles)();
  const { isAuthenticated, user } = useAuth0();
  const userInfo = AccessControl.getUserInfo();
  const userClass = userInfo?.userClass;

  const [state, setState] = useState({
    canEdit: false,
    month: 0,
    year: 0
  });

  const queryClient = useQueryClient();
  const extraKeys = [userInfo.companyUuid];

  return (isAuthenticated &&
    <div
      className="FlightCapacity"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        //minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="flightcapacity"
        pageName="Flight Capacity"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          backgroundColor: "#ffffff",
          minHeight: `calc(100vh - ${(99+2+10+57+4+64)}px)`
        }}
      >
        <div className={classes.rooted}
             style={{ minHeight: `calc(100vh - ${(99+2+10+57+4+4+94)}px)`, height: `calc(100vh - ${(99+2+10+57+4)}px)`, width: `calc(100vw - 120px)`, maxWidth: `calc(100vw - 120px)`}}>
          <FlightCapacityList month={state.month} year={state.year} canEdit={state.canEdit} classes={classes} canEditFuelLogs={state.canEditFuelLogs} userClass={userClass}/>
        </div>
      </div>
      <PageFooter></PageFooter>
    </div>

  );
}

export default FlightCapacity;
